import React from "react";
import PropTypes from "prop-types";
import { Event } from "../Tracking";

const HorizontalLinkList = props => (
  <ul style={{ display: 'flex', flexDirection: 'row', listStyle: 'none', padding: 0, margin: 0, gap: '4px' }}>
    {props.items.map(item => {
      const isActive = item === props.selectedItem;
      return (
        <li key={item} style={{ display: 'inline-block' }}>
          <a
            onClick={() => {
              Event("Energy Chart Windows Event", "Select Item", item);
              if (item !== props.selectedItem) props.onChange(item);
            }}
            style={{
              display: 'inline-block',
              padding: '0 0.5rem',
              paddingTop: isActive ? '4px' : '0',
              fontWeight: 500,
              cursor: isActive ? 'default' : 'pointer',
              borderBottom: isActive ? '4px solid #f06c00' : 'none',
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            {item}
          </a>
        </li>
      );
    })}
  </ul>
);

HorizontalLinkList.propTypes = {
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  selectedItem: PropTypes.string
};

export default HorizontalLinkList;
